<template>
	<div class="offline">
		<!-- 顶部导航 -->
		<div class="nav">
		
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<div>方案获取</div>
			<span></span>
		</div>
		<!-- 表单 -->
		<div class="cotent">
			<div class="backgd">
				<span>在线免费获取设计图纸方案报价</span>
		
				<!-- <img src="../../assets/design.png" alt=""> -->
			</div>
			<!-- 填写内容 -->
			<div class="main">
				<van-cell-group class="main_from">
					<van-field v-model="tel" clearable label="手机号" type="number" placeholder="请输入手机号" />
					<van-field v-model="code" center clearable label="验证码" placeholder="验证码" type="number">
						<van-button slot="button" @click="getcodel" color="#07c160" size="mini" :disabled="iscode" round>{{buttonMsg}}</van-button>
					</van-field>
					<van-field v-model="user" clearable label="联系人" placeholder="请输入联系人" type="text"/>
					<van-field v-model="size" clearable label="面积大小" type="number" placeholder="请输入办公面积" />
				</van-cell-group>
				<!-- 上传图纸 -->
				<van-panel title="上传图纸" class="main_upload">
					<div slot="default" class="default">
						<div class="tips">请上传小于10M图纸及备注信息</div>
						<van-uploader :after-read="subCamera" v-model="fileList" :max-count="2" />
					</div>
				</van-panel>
				<div class="doubt">需要上门测量服务,请联系：400-8722-000</div>
				<div class="sub_btn">
					<van-button color="#f1452f" round size="small" @click="msg">提交</van-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tel: '',
				code: '',
				user: '',
				size: '',
				iscode: false,
				buttonMsg: '获取验证码',
				iphon: '',
				codes: '',
				fileList: [],
				annex: [] //附件列表
			}
		},
		methods: {
			msg() {
				var that = this;
				if (that.tel == '') {
					that.$toast('请输入手机号');
					return false;
				}
				if (that.code == '') {
					that.$toast('请输入验证码');
					return false;
				}
				if (that.tel != that.iphon || that.code != that.codes) {
					that.$toast('验证码错误');
					return false;
				}
				if (that.user == '') {
					that.$toast('联系人不能为空');
					return false;
				}
				if (that.size == '') {
					that.$toast('面积不能为空');
					return false;
				}
				const toast = that.$toast.loading({
					duration: 0,
					forbidClick: true,
					message: '提交中',
					loadingType: 'spinner'
				});
				that.$axios.post(baseUrl + '/mobile/Base/design', {
					lxr: that.user,
					tel: that.tel,
					size: that.size,
					image: that.annex
				}).then(function(res) {
					if (res.data.code == 19) {
						that.$toast(res.data.msg);
						setTimeout(function() {
							that.$router.push({
								path: '/Home'
							})
						}, 2000)
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			//获取验证码
			getcodel() {
				var that = this;
				if (that.tel === '') {
					that.$toast('请填写手机号');
					return false;
				} else if (that.tel && (!(/^[1][345789]\d{9}$/).test(that.tel) || !(/^[1-9]\d*$/).test(that.tel) ||
						that.tel.length !== 11)) {
					that.$toast('手机号码不符合规范');
					return false;
				} else {
					that.iscode = false
				}
				that.$axios.post(baseUrl + '/mobile/Base/get_code', {
					tel: that.tel
				}).then(function(res) {
					if (res.data.code == 2001) {
						that.$toast(res.data.msg);
						that.iphon = res.data.data.tel;
						that.codes = res.data.data.code;
						that.buttonMsg = 60;
						that.iscode = true
						var auth_timer = setInterval(() => {
							that.buttonMsg--;
							if (that.buttonMsg <= 0) {
								that.buttonMsg = '获取验证码'
								that.iscode = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						that.$toast(res.data.msg);
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			//上传附件
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped>
	@import "design.css";
 .backgd span{
	color: #ffffff;
	font-size:1rem;
	line-height: 3.4rem;
 }
</style>



// WEBPACK FOOTER //
// src/components/home/design.vue